export default __webpack_public_path__ + "static/media/loop4.6bee2928.png";